import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { getDrainsAndTubesSelector } from '../selectors'
import { getServiceIdSelector } from '../../../../user/selectors'
import { getPcrIdSelector } from '../../../../home/selectors'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { DrainsAndTubesConstants } from '../store/drainsAndTubes.constants'
import { IDrainsAndTubesState } from '../store/drainsAndTubes.types'
import { PcrDocsService } from '../../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'
import { setBodValue } from '../../bodySurvey/store/bodySurvey.actions'
import { compareObjectsIfEqual } from '../../../../../utilities/object.util'
import { initialDrainsAndTubesState } from '../store/drainsAndTubes.reducers'

export function* saveDrainsAndTubes() {
  const drainsAndTubes: IDrainsAndTubesState = yield select(getDrainsAndTubesSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      let pcrDocUpdated: IPcr = { ...pcrDoc }

      const currentState = { ...drainsAndTubes }
      const initialState = { ...initialDrainsAndTubesState }

      if (compareObjectsIfEqual(currentState, initialState)) {
        pcrDocUpdated = {
          ...pcrDoc,
          additionalAssessment: {
            ...pcrDoc.additionalAssessment,
            drainsAndTubes: undefined,
          },
        }
      } else {
        pcrDocUpdated = {
          ...pcrDoc,
          additionalAssessment: {
            ...pcrDoc.additionalAssessment,
            drainsAndTubes,
          },
        }
        yield put(setBodValue(true))
      }
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveDrainsAndTubes() error: ${e}`))
    }
  }
}

export function* saveDrainsAndTubesSaga() {
  yield takeLatest(
    [
      DrainsAndTubesConstants.SET_NG_TUBE,
      DrainsAndTubesConstants.SET_NG_TUBE_SUCTION,
      DrainsAndTubesConstants.SET_OG_TUBE,
      DrainsAndTubesConstants.SET_OG_TUBE_SUCTION,
      DrainsAndTubesConstants.SET_CHEST_TUBE_L,
      DrainsAndTubesConstants.SET_CHEST_TUBE_L_SUCTION,
      DrainsAndTubesConstants.SET_CHEST_TUBE_R,
      DrainsAndTubesConstants.SET_CHEST_TUBE_R_SUCTION,
      DrainsAndTubesConstants.SET_FOLEY,
      DrainsAndTubesConstants.SET_FOLEY_COLOR,
      DrainsAndTubesConstants.SET_PEG_TUBE,
      DrainsAndTubesConstants.SET_PEG_TUBE_CAPPED,
      DrainsAndTubesConstants.SET_ILEOSTOMY,
      DrainsAndTubesConstants.SET_COLOSTOMY,
      DrainsAndTubesConstants.SET_VENTRICULOSTOMY,
      DrainsAndTubesConstants.SET_CSF_COLOR,
      DrainsAndTubesConstants.SET_COMMENTS_OTHER,
      DrainsAndTubesConstants.RESET_DRAINS_AND_TUBES,
    ],
    performWithMutexHOG,
    saveDrainsAndTubes
  )
}
